import { RootState } from "store";

export const searchQuery  = (state:RootState) => state.inventory.searchQuery;
export const sort         = (state:RootState) => state.inventory.sort;
export const filter       = (state:RootState) => state.inventory.filter;
export const page         = (state:RootState) => state.inventory.page;

export const slug         = (state:RootState) => state.inventory.slug;